import React from "react";
import { GANTT_HOVER_BG, GANTT_HOVER_BG_END } from "@/shared/colors";

type BarGradientDefProps = {
	id: string;
	isHighlighted: boolean;
	backgroundColor: string;
	backgroundSelectedColor: string;
};

export const BarGradientDef: React.FC<BarGradientDefProps> = ({
	id,
	isHighlighted,
	backgroundColor,
	backgroundSelectedColor,
}) => (
	<linearGradient id={id} x1="0%" y1="0%" x2="100%" y2="100%">
		<stop
			offset="0%"
			stopColor={isHighlighted ? GANTT_HOVER_BG : backgroundColor}
		/>
		<stop
			offset="100%"
			stopColor={isHighlighted ? GANTT_HOVER_BG_END : backgroundSelectedColor}
		/>
	</linearGradient>
);
